//    此文件为所有的接口URL地址
//    测试环境
// const baseUrl = '/api/gate' //   业务接口basenpm
//  开发环境
// const baseUrl = 'http://116.205.240.38:10022/gate';
const baseUrl = '/api';

const ServiceUrls = {

  //    登录模块
  loginByPwd: baseUrl+'/entpersonal/open/admin/loginByPwd' ,// 登录
  getAccountSetting:baseUrl+'/entinfo/ent/entWeb/getAccountSetting', // 获取信息
  accountSetting:baseUrl+'/entinfo/ent/entWeb/accountSetting', // 修改信息
  getWebInfo:baseUrl+'/entinfo/open/entWeb/getWebInfo',   // 获取官网信息
  getWebVideoInfo:baseUrl+'/entinfo/open/entWeb/getWebVideoInfo',   // 获取官网信息
  verifyExhibition:baseUrl+'/entinfo/open/entWeb/verifyExhibition', // 验证展厅是否正确
  saveEntWeb:baseUrl+'/entinfo/ent/entWeb/saveEntWeb',  // 保存官网信息
  saveEntVideo:baseUrl+'/entinfo/ent/entWeb/saveEntVideo',  // 保存视频号信息
  getExhibition:baseUrl+'/entinfo/open/entWeb/getExhibition',// 获取展厅信息
  uploadFile:baseUrl+'/entinfo/ent/entWeb/uploadFile', // 上传图片
  uploadVideo:baseUrl+'/entinfo/ent/entWeb/uploadVideo', // 上传图片
  verify51Config:baseUrl+'/entinfo/ent/r51/verify51Config', // 是否配置51模型
  verify51True:baseUrl+'/entinfo/ent/r51/verify51True', // 配置51模型
  getModelTypeList:baseUrl+'/entinfo/ent/r51/getModelTypeList', // 获取模型数据
  getModelPage:baseUrl+'/entinfo/ent/r51/getModelPage',  // 模型列表
  list:baseUrl+"/entpersonal/ent/org/getOrgList", // 企业列表
  delete:baseUrl+'/entpersonal/ent/org/deleteOrg', // 删除组织
  add:baseUrl+"/entpersonal/ent/org/insertOrg",  // 新增组织
  update:baseUrl+'/entpersonal/ent/org/modifyOrg', // 编辑组织
  getPage:baseUrl+'/entpersonal/ent/member/getOrgCount', // 部门人员数量列表
  getMemCount:baseUrl+'/entpersonal/ent/member/getMemCount', // 部门人员数量列表
  userList:baseUrl+'/entpersonal/ent/member/getPage', // 员工列表
  addUser:baseUrl+'/entpersonal/ent/member/add',  // 新增员工
  transfer:baseUrl+'/appletpersonal/ent/sales/transfer', // 客户移交
  updateUser:baseUrl+'/entpersonal/ent/member/modifyMember', // 编辑员工
  getUserInfo:baseUrl+'/entpersonal/ent/member/getInfo', // 获取员工详情
  modifyDftCard:baseUrl+'/entpersonal/ent/member/modifyDftCard', // 设置默认名片
  updateStatus:baseUrl+'/entpersonal/ent/member/updateStatus',  // 启用和禁用
  categoryList:baseUrl+'/entmall/ent/item-ctg/getList', // 商品类目列表
  categoryupdate:baseUrl+'/entmall/ent/item-ctg/modify', // 商品类目编辑
  categoryadd:baseUrl+'/entmall/ent/item-ctg/insert', // 商品类目新增
  categorydelete:baseUrl+'/entmall/ent/item-ctg/delete', // 商品类目删除
  modifyOrder:baseUrl+'/entmall/ent/item-ctg/modifyOrder', // 修改类目顺序
  goodsList:baseUrl+'/entmall/ent/item/getItemPage', // 商品列表
  getUnitList:baseUrl+'/entmall/ent/item/getUnitList', // 商品单位列表
  goodsadd:baseUrl+'/entmall/ent/item/insertItem', // 新增商品
  deleteItem:baseUrl+'/entmall/ent/item/deleteItem', // 删除商品
  goodsupdata:baseUrl+'/entmall/ent/item/modifyItem', // 编辑商品
  batchModifyItem:baseUrl+'/entmall/ent/item/batchModifyItem', // 批量编辑商品
  cancelLabel:baseUrl+'/entmall/ent/item/cancelLabel', // 取消精选
  setLabel:baseUrl+'/entmall/ent/item/setLabel', // 设置精选
  modifyOnSale:baseUrl+'/entmall/ent/item/modifyOnSale', // 上下架
  editorSort:baseUrl+'/entmall/ent/item/modifyOrder', // 编辑排序
  goodGetInfo:baseUrl+'/entmall/ent/item/getInfo', // 商品详情
  getFlowTrend:baseUrl+'/entpersonal/ent/statistic/getFlowTrend', // 流量趋势
  queryEntCustomStatistic:baseUrl+'/entpersonal/ent/statistic/queryEntCustomStatistic', // 流量统计
  getMemberSalesList:baseUrl+'/entpersonal/ent/statistic/getMemberSalesList', // 员工销售数据列表
  getMemberSalesDetailList:baseUrl+'/entpersonal/ent/statistic/getMemberSalesDetailList', // 员工销售详情列表
  getOrgSalesAmount:baseUrl+'/entpersonal/ent/statistic/getOrgSalesAmount', // 组织销售额
  admingetEntSalesCurve: baseUrl + '/entmall/ent/stat/getEntSalesCurve', // 销售额曲线
  getEntSalesCurve:baseUrl+'/entpersonal/ent/statistic/getEntSalesCurve', // 获取公司销售曲线及商品销量
  getitemPayRank: baseUrl + '/entmall/open/stat/itemPayRank',
  orderCount:baseUrl+'/entmall/ent/stat/orderCount', // 订单概览
  orderChart:baseUrl+'/entmall/ent/stat/orderChart', // 订单折线图
  orderByOrg:baseUrl+'/entmall/ent/stat/orderByOrg', // 订单占比
  getOrderPage:baseUrl+'/entmall/ent/order/getOrderPage', // 订单列表
  getInfo:baseUrl+'/entmall/ent/order/getInfo', // 订单详情
  changeSettlementNot:baseUrl+'/entmall/ent/order/changeSettlementNot', // 修改结算接口
  deliver:baseUrl+'/entmall/ent/order/deliver', // 发货接口
  cancelOrder:baseUrl+'/entmall/ent/order/cancelOrder', // 取消接口
  getLogPage:baseUrl+'/adminpersonal/open/log/getLogPage', // 操作记录
  getEntCreateDate:baseUrl+'/entinfo/open/entWeb/getEntCreateDate', // 企业创建时间
  getMapAddress:baseUrl+'/entinfo/ent/entWeb/getMapAddress', // 企业创建时间
}
export default ServiceUrls
